import './bml-vacancy-detail.scss';
import { fetchWithAccessCheck, formatDate } from '../../dynamic-page/page-access';

const TEMPLATE = `
<section class="vacancy-information container-fluid">
    <div class="row">
        <div class="col-lg-6 col-md-6">
            <p class="section-label"
               data-content=""
               data-type="textarea"
               data-global="true"></p>
        </div>
        <div class="col-lg-6 col-md-6">
            <h1 class="vacancy-head"
                data-content=""
                data-type="textarea"
                data-global="true"></h1>
            <p class="vacancy-full-description"
               data-content=""
               data-type="textarea"
               data-global="true"></p>
            <h3>Вимоги</h3>
            <div class="vacancy-requirements"
               data-content=""
               data-type="textarea"
               data-global="true"></div>
            <h3>Умови роботи</h3>
            <div class="vacancy-conditions"
               data-content=""
               data-type="textarea"
               data-global="true"></div>
        </div>
    </div>
</section>

<section id="vacancy-content" class="vacancy-content fade-up" data-section="vacancy-content"
         data-animate-child>
</section>

<section class="contact-us fade-up" id="vacancy-apply-form">
    <div class="contact-circles-container" data-animate-circles>
        <div class="contact-circle contact-circle-large"></div>
        <div class="contact-circle contact-circle-medium"></div>
        <div class="contact-circle contact-circle-small"></div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6" data-animate-child style="padding-right:3%;">
                <p class="contact-us-vacancy">Твоя історія в BML починається тут</p>
                <p class="contact-us-vacancy-text">BOGOMOLETS LABORATORY — сучасна лабораторія з експертизою в
                    дерматології та онкодіагностиці.
                    Працюй з фахівцями, яким довіряють тисячі пацієнтів.</p>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="contact-container" data-animate-child>
                    <form class="contact-form vacancy-apply-form">
                        <div class="input-row">
                            <div class="input-wrapper" data-animate-child>
                                <input type="text" class="input-field" id="vacancy-name" placeholder="">
                                <label for="vacancy-name" class="floating-label">Ім'я</label>
                            </div>
                            <div class="input-wrapper wrapper-phone" data-animate-child>
                                <input type="tel" id="vacancy-phone" class="input-field">
                                <label for="vacancy-phone" class="floating-label">Телефон</label>
                            </div>
                        </div>
                        <div class="input-row">
                            <div class="input-wrapper" data-animate-child>
                                <input type="email" class="input-field" id="vacancy-email" placeholder="">
                                <label for="vacancy-email" class="floating-label">E-Mail</label>
                            </div>
                            <div class="input-wrapper wrapper-phone" data-animate-child>
                                <input type="text" class="input-field" id="cv-display" placeholder="" readonly>
                                <input type="file" id="cv" class="input-field" style="display: none;"
                                       accept=".pdf,.doc,.docx">
                                <label for="cv-display" class="floating-label">Надіслати резюме</label>
                                <div class="upload-icon" id="upload-trigger">
                                    <img src="/images/upload-icon.svg" alt="Upload">
                                </div>
                            </div>
                        </div>
                        <div class="input-wrapper" data-animate-child>
                            <textarea class="input-field text-area" id="vacancy-message" placeholder=""></textarea>
                            <label for="vacancy-message" class="floating-label">Коментар</label>
                        </div>
                        <div class="input-wrapper checkbox-wrapper" data-animate-child>
                            <label class="checkbox-label">
                                <input type="checkbox" class="checkbox-input">
                                <span class="checkbox-text">Я прочитав, розумію та погоджуюсь з <a href="/privacy-policy" target="_blank">Політикою конфіденційності</a> та <a href="/personal-data-policy" target="_blank">Політикою обробки персональних даних</a></span>
                            </label>
                        </div>
                        <div class="input-wrapper" data-animate-child>
                            <button type="submit" class="submit-btn">Відправити резюме</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
`;

function buildContentMapping(slug) {
    return [
        { selector: '.section-label',       contentId: `${slug}-date` },
        { selector: '.vacancy-head',            contentId: `${slug}-full-title` },
        { selector: '.vacancy-full-description',contentId: `${slug}-full-description` },
        { selector: '.vacancy-requirements',    contentId: `${slug}-requirements` },
        { selector: '.vacancy-conditions',      contentId: `${slug}-conditions` },
    ];
}

class BmlVacancyDetail extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;

        const path = window.location.pathname;
        const pathMatch = path.match(/\/vacancy\/([^/]+)/);
        const slug = pathMatch ? pathMatch[1] : new URLSearchParams(window.location.search).get('slug');
        if (!slug) return;

        // Set data-page synchronously so initAdminInterface (called at DOMContentLoaded)
        // doesn't bail out due to missing data-page attribute.
        if (!document.body.getAttribute('data-page')) {
            document.body.setAttribute('data-page', `Vacancy - ${slug}`);
        }

        // Phase 1 (sync): wire data-content so initContentEditor picks them up at DOMContentLoaded
        this._applyContentIds(slug);

        // Phase 2 (async): fetch entity, verify access, apply fallback text
        this._loadData(slug);

        // Phase 3: after content editor applies API data, remove duplicate conditions
        // (SSR may show correct page-specific content but client API returns global duplicate)
        setTimeout(() => this._deduplicateConditions(), 700);

        this._initFileUpload();
    }

    _applyContentIds(slug) {
        buildContentMapping(slug).forEach(({ selector, contentId }) => {
            const el = this.querySelector(selector);
            if (el) {
                el.setAttribute('data-content', contentId);
                el.setAttribute('data-page', `Vacancy - ${slug}`);
            }
        });
    }

    async _loadData(slug) {
        const data = await fetchWithAccessCheck(`/api/vacancies/slug/${slug}`, 'vacancy');

        if (data) {
            const head = this.querySelector('.vacancy-head');
            // Skip overwriting document.title when SSR already filled the title element
            if (!head?.textContent?.trim()) {
                document.title = `${data.title} - BML`;
            }

            const curPage = document.body.getAttribute('data-page') || '';
            if (!curPage || curPage === 'Vacancy-page') {
                document.body.setAttribute('data-page', `Vacancy - ${data.title}`);
            }

            if (head && !head.textContent.trim()) head.textContent = data.title;

            const desc = this.querySelector('.vacancy-full-description');
            if (desc && !desc.textContent.trim()) desc.textContent = data.preview_text || '';

            const dateEl = this.querySelector('.section-label');
            if (dateEl && !dateEl.textContent.trim()) {
                dateEl.textContent = `Вакансія від ${formatDate(data.published_at || data.created_at)}`;
            }
        }

        // Content loading and edit buttons are handled by initContentEditor (DOMContentLoaded).
        // _applyContentIds runs synchronously before DOMContentLoaded, so all [data-content]
        // elements are already wired when initContentEditor queries the DOM.

        // Sync document.title after content editor renders the final title
        setTimeout(() => {
            const head = this.querySelector('.vacancy-head');
            const rendered = head?.textContent?.trim();
            if (rendered) document.title = `${rendered} - BML`;
            this._collapseBlankLines();
        }, 350);
    }

    _deduplicateConditions() {
        const req = this.querySelector('.vacancy-requirements');
        const cond = this.querySelector('.vacancy-conditions');
        if (!req || !cond) return;
        const reqHtml = req.innerHTML.trim();
        const condHtml = cond.innerHTML.trim();
        if (reqHtml && condHtml && reqHtml === condHtml) {
            cond.innerHTML = '';
        }
    }

    _collapseBlankLines() {
        ['.vacancy-requirements', '.vacancy-conditions'].forEach(sel => {
            const el = this.querySelector(sel);
            if (!el) return;
            // Plain-text case: textContent only (no child elements)
            if (!el.children.length && el.textContent.includes('\n\n')) {
                el.textContent = el.textContent.replace(/\n{2,}/g, '\n');
            }
        });
    }

    _initFileUpload() {
        const trigger = this.querySelector('#upload-trigger');
        const fileInput = this.querySelector('#cv');
        const display = this.querySelector('#cv-display');
        if (!trigger || !fileInput || !display) return;

        trigger.addEventListener('click', () => fileInput.click());
        fileInput.addEventListener('change', () => {
            display.value = fileInput.files[0]?.name || '';
        });
    }
}

customElements.define('bml-vacancy-detail', BmlVacancyDetail);
